import { DEV_ENV } from 'env/environment'

export const warnDev = (message: string) => {
  if (!DEV_ENV) return

  console.warn(message)
}
